import React from 'react';
import { motion } from 'framer-motion';
import { Truck, Droplets, Wrench, Phone } from 'lucide-react';

const WASH_IMG = 'https://images.pexels.com/photos/5854034/pexels-photo-5854034.jpeg?auto=compress&cs=tinysrgb&w=900&q=85';

const steps = [
  {
    Icon: Truck,
    step: '01',
    title: 'Abholung',
    desc: 'Wir kommen zu Ihnen und holen Ihre Gardinen kostenlos ab — kein Stress, keine Leiter.',
  },
  {
    Icon: Droplets,
    step: '02',
    title: 'Reinigung & Aufdämpfen',
    desc: 'Fachgerechte Wäsche, schonende Trocknung und professionelles Aufdämpfen für perfekten Fall.',
  },
  {
    Icon: Wrench,
    step: '03',
    title: 'Montage vor Ort',
    desc: 'Frisch gewaschen hängen Ihre Gardinen wieder — wir montieren alles sauber und pünktlich.',
  },
];

const CurtainWash = () => (
  <section
    id="waschservice"
    data-testid="curtain-wash-section"
    className="py-0 bg-[#F8F5F0]"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
        {/* Image side */}
        <motion.div
          className="relative h-80 lg:h-auto overflow-hidden"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8 }}
          data-testid="curtain-wash-image"
        >
          <img
            src={WASH_IMG}
            alt="Gardinenwaschservice — frische, saubere Gardinen"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent" />
          <div className="absolute bottom-8 left-8 bg-[#C4944A] px-5 py-3">
            <span className="font-cormorant text-lg text-white font-semibold">
              Ihr Alleinstellungsmerkmal
            </span>
          </div>
        </motion.div>

        {/* Content side */}
        <motion.div
          className="bg-[#2A2A2A] px-8 sm:px-12 py-16 lg:py-20 flex flex-col justify-center"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.8 }}
        >
          <span className="text-[11px] tracking-[0.22em] uppercase text-[#C4944A] font-outfit mb-4 block">
            Gardinenwaschservice Berlin
          </span>
          <h2 className="font-cormorant text-4xl md:text-5xl text-white font-medium leading-tight mb-4">
            Wir holen.
            <br />Wir waschen.
            <br />Wir hängen auf.
          </h2>
          <p className="font-outfit text-sm text-white/65 leading-relaxed mb-10">
            Ihr Gardinenwaschservice in Berlin — bequem und professionell. Kein Leitersteigen, keine tropfenden Gardinen, kein Stress.
          </p>

          <div className="space-y-7 mb-12">
            {steps.map((step, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                className="flex items-start gap-5"
                data-testid={`wash-step-${i}`}
              >
                <div className="flex-shrink-0 w-10 h-10 bg-[#8B7355]/20 border border-[#8B7355]/30 flex items-center justify-center">
                  <step.Icon size={16} className="text-[#C4944A]" />
                </div>
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-[10px] tracking-[0.2em] text-[#C4944A] font-outfit">{step.step}</span>
                    <span className="font-cormorant text-lg text-white font-semibold">{step.title}</span>
                  </div>
                  <p className="font-outfit text-sm text-white/60 leading-relaxed">{step.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <a
            href="tel:+493043115080"
            data-testid="wash-cta-phone"
            className="inline-flex items-center gap-2.5 bg-[#8B7355] text-white px-7 py-4 font-outfit text-xs tracking-[0.18em] uppercase hover:bg-[#C4944A] transition-colors duration-200 self-start"
          >
            <Phone size={13} />
            Jetzt anrufen: 030 / 4 31 15 80
          </a>
        </motion.div>
      </div>
    </div>
  </section>
);

export default CurtainWash;
